import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { ItemConfirmComponent } from '../_components/item-confirm/item-confirm.component';
import { MessagesService } from '@core/_services/messages.service';
import { ConfirmationService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { deleteList } from '@core/_utils/tools.utils';
import { dateFormat, setFormRangeData, setRangeDate } from '@core/_utils/date.utils';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'page-last-connect',
    templateUrl: './page-last-connect.component.html',
    styleUrls: ['./page-last-connect.component.scss'],
})
export class PageLastConnectComponent implements OnInit {
    public lastConnect = [];
    public isDesktop: boolean = false;
    public error = false;
    public itemConfirm: ItemConfirmComponent;
    public stateList: SelectItem[];
    public visible: boolean = false;
    public rangeDates: Date[] | undefined;

    public listColumns = [];

    constructor(
        public menu: MenuServiceInt,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.stateList = [
            { label: this.translate.instant('All'), value: null },
            { label: this.translate.instant('Succes'), value: '1' },
            { label: this.translate.instant('Failed'), value: '0' },
        ];
        this.listColumns = [
            { header: this.translate.instant('Login_1'), field: 'login', type: 'String', sort: 'login' },
            { header: this.translate.instant('Date'), field: 'datecnx', type: 'DateTime', sort: 'datecnx' },
            { header: this.translate.instant('Ip'), field: 'remoteadr', type: 'String', sort: 'remoteadr' },
            { header: this.translate.instant('Forwarded'), field: 'forwardfor', type: 'String', sort: 'forwardfor' },
            { header: this.translate.instant('State'), field: 'statecnx', type: 'String', sort: null },
            { header: this.translate.instant('&doc_owner'), field: 'username', type: 'String', sort: 'username' },
        ];
        this.findAll();
        this.commonService.checkReset();
    }

    private async findAll() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getlastconnections',''));
            this.lastConnect = wRes.data.data.map((item) => {
                item.datecnx = item.datecnx + '|' + dateFormat(item.datecnx, 'dd/MM/yyyy HH:mm:ss');
                return item;
            });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    public clickDateDelCnx() {
        this.visible = true;
    }

    public clickDelCnx() {
        let wRange = setRangeDate(this.rangeDates);
        if (wRange.empty === true) {
            return;
        }
        this.execDelCnx(wRange);
    }

    private async execDelCnx(aRange) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('dellastconnections',setFormRangeData(aRange)));
            this.closeDia();
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Delete_KO'));
            this.closeDia();
            return;
        }
        this._messageService.addSuccess(this.translate.instant('Delete_OK'));        
        await this.findAll();
    }

    public closeDia() {
        this.visible = false;
    }

    public deleteConnect($event, aData) {
        let wIndex = -1;
        let wDate = '';
        $event.stopPropagation();
        wIndex = aData.datecnx.indexOf('|');
        if (wIndex !== -1) {
            wDate = aData.datecnx.substring(wIndex + 1);
        }
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelC', {label: aData.login, date: wDate}),
            () => {
                this.delete(aData);
            }
        );
    }

    public async delete(aData) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('deleteconnect',aData.id));
            this.lastConnect = [...deleteList(this.lastConnect, wRes.data)];
            this._messageService.addSuccess(this.translate.instant('Update_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }
}
